// TMDB attribution, as the TMDB API Terms of Use require: the notice below
// "prominently in or on" the app, and an approved TMDB logo that is less
// prominent than Aluvo's own. The logo is TMDB's official "Alt short (blue)"
// SVG, unmodified (public/tmdb-logo.svg, SHA-256 8e7b30f7…, the fingerprint in
// TMDB's own filename). Its green→blue gradient on a transparent background
// reads on both the dark and light themes, so it is never recoloured.
// See docs/custom-rankings.md → TMDB attribution.
import styles from './TmdbAttribution.module.css';

export const TMDB_NOTICE = 'This website uses TMDB and the TMDB APIs but is not endorsed, certified, or otherwise approved by TMDB.';

/**
 * variant 'full'    logo + notice (About → Credits)
 *         'compact' small logo + notice (public ranking pages)
 *         'text'    notice only (site footer, next to a link to the credits)
 */
export default function TmdbAttribution({ variant = 'full', className = '' }) {
    return (
        <div className={`${styles.attribution} ${styles[variant] || ''} ${className}`}>
            {variant !== 'text' && (
                <a href="https://www.themoviedb.org/" target="_blank" rel="noopener noreferrer" className={styles.logoLink}>
                    <img src="/tmdb-logo.svg" alt="The Movie Database (TMDB)" className={styles.logo} width="273" height="36" loading="lazy" />
                </a>
            )}
            <p className={styles.notice}>{TMDB_NOTICE}</p>
        </div>
    );
}
